import { render, staticRenderFns } from "./Pemda.vue?vue&type=template&id=a24d4c72&"
import script from "./Pemda.vue?vue&type=script&lang=js&"
export * from "./Pemda.vue?vue&type=script&lang=js&"
import style0 from "./Pemda.vue?vue&type=style&index=0&id=a24d4c72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports